export { WidthArchiveLabel } from './WidthArchiveLabel';
